import * as THREE from "three";

export class Globe{
  mesh : THREE.Mesh;
  rotation_speed : number;

  constructor(){
    this.rotation_speed = 0.5
    const texture_loader = new THREE.TextureLoader();
    const texture = texture_loader.load("world.png", (texture) => {console.log("Texture");});
    texture.colorSpace = THREE.SRGBColorSpace;

    const geometry = new THREE.SphereGeometry(28,64,32);
    const material = new THREE.MeshBasicMaterial({map : texture});
    this.mesh = new THREE.Mesh(geometry, material)

    // First rotate so that the poles are on the left and right of the screen
    this.mesh.rotateOnAxis(new THREE.Vector3(0,0,1), THREE.MathUtils.degToRad(90));
  }

  rotate(speed_multiplier : number){
    // 'Daytime' - earth's rotation
    // The poles are aligned along the y axis now, 
    this.mesh.rotateOnAxis(new THREE.Vector3(0,1,0), 0.00125);
    // Orbit, the rotation of the sphere from the perspective of the
    // satellite. Orbital period is 16/day (above) - when at the optimum height
    this.mesh.rotateOnWorldAxis(new THREE.Vector3(0,0,1), speed_multiplier *  0.02);
  }
}
